import { makeStyles } from '@material-ui/core/styles';

export const useEditSharedStyles = makeStyles(() => ({
  whiteActionIcon: {
    width: 16,
    height: 16,
    fill: 'white',
  },
}));
